import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  locationDropdownDefaultTitle: {
    defaultMessage: 'Select location',
    id: 'q2v8ah',
    description: 'Default title for location dropdown',
  },
});
